import React from 'react'
import c from 'classnames'

import { INTENTS_EMOJI, INTENTS_LABELS } from 'reducers/quoteReducers'

import './ReactionBubble.scss'

export default function ReactionBubble({ reaction, size = 'regular' }) {
  return (
    <span className={c('reaction-bubble', `reaction-bubble-${size}`)}>
      {INTENTS_EMOJI[reaction]} "{INTENTS_LABELS[reaction]}"
    </span>
  )
}
